import { ConversationPlatform } from "@redotech/redo-model/conversation";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const supportAnalytics = {
  name: "supportAnalytics" as const,
  input: z.object({
    start: z.date(),
    end: z.date(),
    channels: z.array(createEnum(ConversationPlatform)).optional(),
  }),

  output: z.object({
    current: z.object({
      aiMetrics: z.object({
        ticketAutomationRate: z.number(),
        totalTicketsAutomated: z.number(),
        medianResolutionTime: z.number(),
        averageCsatScore: z.number(),
        costSavingsAnalysis: z.object({
          assumptions: z.object({
            annualSalary: z.number(),
            weeksPerYear: z.number(),
            ticketsPerDay: z.number(),
            workDaysPerWeek: z.number(),
            source: z.string(),
          }),
          savings: z.number(),
        }),
      }),
      humanMetrics: z.object({
        medianResolutionTime: z.number(),
        averageCsatScore: z.number(),
      }),
      aiTimeSeries: z.object({
        numberOfTicketsResolved: z.array(
          z.object({ date: z.date(), count: z.number() }),
        ),
      }),
      humanTimeSeries: z.object({
        numberOfTicketsResolved: z.array(
          z.object({ date: z.date(), count: z.number() }),
        ),
      }),
    }),
    previous: z.object({
      aiMetrics: z.object({
        ticketAutomationRate: z.number(),
        totalTicketsAutomated: z.number(),
        medianResolutionTime: z.number(),
        averageCsatScore: z.number(),
        costSavingsAnalysis: z.object({
          assumptions: z.object({
            annualSalary: z.number(),
            weeksPerYear: z.number(),
            ticketsPerDay: z.number(),
            workDaysPerWeek: z.number(),
            source: z.string(),
          }),
          savings: z.number(),
        }),
      }),
      humanMetrics: z.object({
        medianResolutionTime: z.number(),
        averageCsatScore: z.number(),
      }),
      aiTimeSeries: z.object({
        numberOfTicketsResolved: z.array(
          z.object({ date: z.date(), count: z.number() }),
        ),
      }),
      humanTimeSeries: z.object({
        numberOfTicketsResolved: z.array(
          z.object({ date: z.date(), count: z.number() }),
        ),
      }),
    }),
    staticMetrics: z.object({
      deflectedTicketsByMonth: z.array(
        z.object({ month: z.string(), count: z.number() }),
      ),
    }),
  }),
};
